import get from 'lodash.get'

// actions which come from server
const actionResolver = [
    {
        input: "add",
        output: "create",
    },
    {
        input: "change",
        output: "update"
    },
    {
        input: "delete",
        output: "delete"
    },
    {
        input: "view",
        output: "read"
    },
]

// abilities which come from server
const subjectResolver = [
    {
        input: "user",
        output: "user"
    },
    {
        input: "measurement",
        output: "measurement"
    },


    // Railway Structure
    {
        input: "railway",
        output: "railway"
    },
    {
        input: "railwaysector",
        output: "sector"
    },
    {
        input: "station",
        output: "station"
    },
    {
        input: "platform",
        output: "platform"
    },
    {
        input: "bridge",
        output: "bridge"
    },
    {
        input: "naves",
        output: "shed"
    },
    {
        input: "torcevoeograzdenie",
        output: "fencing"
    },
    {
        input: "opora",
        output: "pillar"
    },
    {
        input: "contactwire",
        output: "contactwire"
    },
    {
        input: "mainwire",
        output: "mainwire"
    },


    // Reports
    {
        input: "report",
        output: "report"
    },

    {
        input: "wrapper",
        output: "wrapper"
    },

    // Permissions

    {
        input: "userpermission",
        output: "userpermission"
    },
    {
        input: "userobjectpermission",
        output: "userobjectpermission"
    },
]

// resolver to get ability which come from server
const resolver = (input, resolverSource) => get(resolverSource.filter(action => action.input === input), "[0]['output']")

export const generateUserAbilities = ( serverAbilities ) => serverAbilities.reduce( (permissions, permission) => {
    const initialAbility = permission['codename'].split("_")
    const action = resolver(initialAbility[0], actionResolver)
    const subject = resolver(initialAbility[1], subjectResolver)

    if (action && subject) permissions.push({ action: action, subject: subject})

    return permissions;

}, [])
